import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { LocalStoreService } from './local-store.service';

@Injectable({
  providedIn: 'root'
})
export class DefaultSettingService {

  companyChangedSubject: Subject<any> = new Subject();
  companyChanged$ = this.companyChangedSubject.asObservable();
  tourEndSubject: Subject<any> = new Subject();
  tourEnded$ = this.tourEndSubject.asObservable();
  constructor(
    private _localStoreService: LocalStoreService
  ) { }

  private companyId = "company_id";
  private warehouseId = "warehouse_id";
  private printPointName = "printPointName";
  public clear() {
    this._localStoreService.clear();
  }
  public setCompanyId(value) {
    this._localStoreService.setItem(this.companyId, value);
  }
  public getCompanyId() {
    if (this._localStoreService.getItem(this.companyId) == null)
      return -1;
    return this._localStoreService.getItem(this.companyId);
  }
  public setWarehouseId(value) {
    this._localStoreService.setItem(this.warehouseId, value);
  }
  public getWarehouseId() {
    if (this._localStoreService.getItem(this.warehouseId) == null)
      return -1;
    return this._localStoreService.getItem(this.warehouseId);
  }
  public setPrintPointName(value) {
    this._localStoreService.setItem(this.printPointName, value);
  }
  public getPrintPointName() {
    if (this._localStoreService.getItem(this.printPointName) == null)
      return "";
    return this._localStoreService.getItem(this.printPointName);
  }
  public tourSendNext(nextComponent:string){
    this.tourEndSubject.next(nextComponent)
  }
}
